'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectOutputModalCreateController from "./controller/projectOutputModalCreate";
import ProjectOutputTableDirective from "./directive/projectOutputTable";
import ProjectOutputService from "./service/projectOutput";

export default angular.module('investmentProject.project.output', [])
    // контроллеры
    .controller('ProjectOutputModalCreateController', ProjectOutputModalCreateController)
    // директивы
    .directive('projectOutputTable', ProjectOutputTableDirective)
    .factory('ProjectOutputService', ProjectOutputService)
    .name;
